import React from "react";
import "./career.css";

const Career = () => {
  return (
    <>
      <br></br>
      <div className="container">
        <div className="career-jumbo jumbotron">
          <h1 className="text-center">Career</h1>
        </div>
      </div>
    </>
  );
};

export default Career;
